import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@adsk/alloy-react-box';
import Divider from '@adsk/alloy-react-divider';
import { useLocale } from '@adsk/alloy-react-locale';
const ProductPickerHeader = _ref => {
  let {
    className,
    style
  } = _ref;
  const {
    T
  } = useLocale(_ref2 => {
    let {
      locale
    } = _ref2;
    return require(`./i18n/${locale}.json`);
  });
  return /*#__PURE__*/React.createElement(Box, {
    padding: "0 15px",
    className: className,
    style: style
  }, /*#__PURE__*/React.createElement(Box, {
    padding: "8px 0",
    color: "charcoal700",
    typography: "heading4"
  }, T.translate('AVAILABLE_PROJECT')), /*#__PURE__*/React.createElement(Divider, null));
};
ProductPickerHeader.displayName = 'ProductPickerHeader';
ProductPickerHeader.propTypes = {
  /** Styles applied to the root element */
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  /** Class applied to the root element */
  className: PropTypes.string
};
export default ProductPickerHeader;
//# sourceMappingURL=ProductPickerHeader.js.map